/* Codressing: dual-handle range sliders in the filter drawer (markup: snippets/facets-mobile.liquid, .cd-range;
   styles: assets/cd-global.css). Two kinds:
   - data-mode="price": a price_range filter (store price): the handles and the two boxes set hidden gte / lte inputs
     (disabled at the ends, so no filter is sent);
   - data-mode="bucket": a list filter of ranges ("< 10€", "10-25€", "> 60€": Rental Range / Sale range metafields):
     the handles snap to the range edges and tick the matching hidden checkboxes (the URL keeps the list params).
   A change is applied on release / Enter / blur / keyboard pause by an 'input' event from inside the row, which the
   theme's facets form (assets/facets.js, 500 ms debounce) turns into the filtered URL; that row is not re-rendered.
   Other changes re-render the rows (innerHTML), so everything is delegated and read from the markup. */
(function () {
  'use strict';
  if (window.__cdRange) return;
  window.__cdRange = true;

  function toNum(str) {
    var s = String(str == null ? '' : str), out = '', i, c;
    for (i = 0; i < s.length; i++) {
      c = s.charAt(i);
      if (c >= '0' && c <= '9') out += c;
      else if ((c === '.' || c === ',') && out.indexOf('.') < 0) out += '.';
    }
    var n = parseFloat(out);
    return isNaN(n) ? null : n;
  }
  function fmt(n) { return String(Math.round(n * 100) / 100); }
  function key(s) { return s.lo + ':' + s.hi; }

  function state(el) {
    if (el.__cdr) return el.__cdr;
    var s = { el: el, mode: el.getAttribute('data-mode'), cur: el.getAttribute('data-cur') || '' };
    s.lo = Number(el.getAttribute('data-lo'));
    s.hi = Number(el.getAttribute('data-hi'));
    if (s.mode === 'bucket') {
      s.stops = el.getAttribute('data-stops').split(',').map(Number);
      s.open = el.getAttribute('data-open') === '1';
      s.n = s.stops.length - 1;
      s.min = 0;
      s.max = s.n;
      s.boxes = el.querySelectorAll('input.cd-range__b');
    } else {
      s.min = Number(el.getAttribute('data-min')) || 0;
      s.max = Number(el.getAttribute('data-max')) || 0;
      s.gte = el.querySelector('input.cd-range__gte');
      s.lte = el.querySelector('input.cd-range__lte');
    }
    s.rail = el.querySelector('.cd-range__rail');
    s.fill = el.querySelector('.cd-range__fill');
    s.tLo = el.querySelector('.cd-range__thumb[data-k="lo"]');
    s.tHi = el.querySelector('.cd-range__thumb[data-k="hi"]');
    s.iLo = el.querySelector('.cd-range__in[data-k="lo"]');
    s.iHi = el.querySelector('.cd-range__in[data-k="hi"]');
    s.val = el.querySelector('.cd-range__val');
    s.saved = key(s);
    el.__cdr = s;
    return s;
  }

  function frac(s, v) { return s.max > s.min ? (v - s.min) / (s.max - s.min) : 0; }
  function fromFrac(s, f) {
    f = Math.min(1, Math.max(0, f));
    return Math.round(s.min + f * (s.max - s.min));
  }
  /* the amount a handle stands for, as text ("€25", "€60+") */
  function amount(s, k) {
    var v = s[k];
    if (s.mode === 'bucket') return fmt(s.stops[v]) + (k === 'hi' && v === s.n && s.open ? '+' : '');
    return fmt(v);
  }

  function paint(s) {
    var a = frac(s, s.lo) * 100, b = frac(s, s.hi) * 100;
    s.tLo.style.left = a + '%';
    s.tHi.style.left = b + '%';
    s.fill.style.left = a + '%';
    s.fill.style.right = (100 - b) + '%';
    s.tLo.setAttribute('aria-valuenow', s.lo);
    s.tHi.setAttribute('aria-valuenow', s.hi);
    s.tLo.setAttribute('aria-valuetext', s.cur + amount(s, 'lo'));
    s.tHi.setAttribute('aria-valuetext', s.cur + amount(s, 'hi'));
    if (s.val) s.val.textContent = s.cur + amount(s, 'lo') + ' – ' + s.cur + amount(s, 'hi');
    if (s.iLo && document.activeElement !== s.iLo) s.iLo.value = amount(s, 'lo');
    if (s.iHi && document.activeElement !== s.iHi) s.iHi.value = amount(s, 'hi');
  }

  /* bucket handles keep at least one range between them; price handles may meet */
  function set(s, k, v) {
    var gap = s.mode === 'bucket' ? 1 : 0;
    if (k === 'lo') s.lo = Math.max(s.min, Math.min(v, s.hi - gap));
    else s.hi = Math.min(s.max, Math.max(v, s.lo + gap));
    paint(s);
  }

  function commit(s) {
    if (key(s) === s.saved) return;
    s.saved = key(s);
    var src = null, i, b, all;
    if (s.mode === 'bucket') {
      all = s.lo === 0 && s.hi === s.n;
      for (i = 0; i < s.boxes.length; i++) {
        b = Number(s.boxes[i].getAttribute('data-b'));
        s.boxes[i].checked = !all && b >= s.lo && b < s.hi;
      }
      src = s.boxes[0];
    } else {
      s.gte.value = s.lo > s.min ? fmt(s.lo) : '';
      s.lte.value = s.hi < s.max ? fmt(s.hi) : '';
      s.gte.disabled = s.gte.value === '';
      s.lte.disabled = s.lte.value === '';
      src = s.gte;
    }
    if (src) src.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* ---------- drag (mouse, touch, pen) ---------- */
  var drag = null;
  function fracAt(s, x) {
    var r = s.rail.getBoundingClientRect();
    return r.width ? (x - r.left) / r.width : 0;
  }
  function thumbOf(s, k) { return k === 'lo' ? s.tLo : s.tHi; }
  function lift(s, k) {
    s.tLo.style.zIndex = k === 'lo' ? 3 : 2;
    s.tHi.style.zIndex = k === 'hi' ? 3 : 2;
  }

  document.addEventListener('pointerdown', function (e) {
    var rail = e.target.closest && e.target.closest('.cd-range__rail');
    if (!rail || (e.pointerType === 'mouse' && e.button !== 0)) return;
    var s = state(rail.closest('.cd-range'));
    var th = e.target.closest('.cd-range__thumb');
    var v = fromFrac(s, fracAt(s, e.clientX));
    var k;
    if (th) {
      k = th.getAttribute('data-k');
    } else {
      k = Math.abs(v - s.lo) <= Math.abs(v - s.hi) ? 'lo' : 'hi';
      if (v < s.lo) k = 'lo';
      if (v > s.hi) k = 'hi';
      set(s, k, v);
    }
    drag = { s: s, k: k, id: e.pointerId, free: !!th && s.lo === s.hi };
    lift(s, k);
    thumbOf(s, k).classList.add('is-drag');
    try { thumbOf(s, k).focus({ preventScroll: true }); } catch (err) {}
    try { rail.setPointerCapture(e.pointerId); } catch (err) {}
    e.preventDefault();
  });

  document.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    var s = drag.s, v = fromFrac(s, fracAt(s, e.clientX));
    if (drag.free && v !== s.lo) {
      /* both handles on the same spot: the drag direction decides which one moves */
      thumbOf(s, drag.k).classList.remove('is-drag');
      drag.k = v < s.lo ? 'lo' : 'hi';
      drag.free = false;
      lift(s, drag.k);
      thumbOf(s, drag.k).classList.add('is-drag');
    }
    set(s, drag.k, v);
    e.preventDefault();
  });

  function end(e) {
    if (!drag || e.pointerId !== drag.id) return;
    var s = drag.s;
    thumbOf(s, drag.k).classList.remove('is-drag');
    drag = null;
    commit(s);
  }
  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);

  /* ---------- keyboard on the handles ---------- */
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (t.classList && t.classList.contains('cd-range__in') && e.key === 'Enter') {
      e.preventDefault();
      fromInput(t);
      return;
    }
    var th = t.closest && t.closest('.cd-range__thumb');
    if (!th) return;
    var s = state(th.closest('.cd-range')), k = th.getAttribute('data-k');
    var step = s.mode === 'bucket' ? 1 : Math.max(1, Math.round((s.max - s.min) / 100));
    var v = null;
    switch (e.key) {
      case 'ArrowLeft': case 'ArrowDown': v = s[k] - step; break;
      case 'ArrowRight': case 'ArrowUp': v = s[k] + step; break;
      case 'PageDown': v = s[k] - step * 10; break;
      case 'PageUp': v = s[k] + step * 10; break;
      case 'Home': v = s.min; break;
      case 'End': v = s.max; break;
      default: return;
    }
    e.preventDefault();
    lift(s, k);
    set(s, k, v);
    clearTimeout(s.kt);
    s.kt = setTimeout(function () { commit(s); }, 450);
  });

  /* ---------- the two boxes ---------- */
  function fromInput(inp) {
    var s = state(inp.closest('.cd-range')), k = inp.getAttribute('data-k'), n = toNum(inp.value), v, i;
    if (n === null) { inp.value = amount(s, k); return; }
    v = n;
    if (s.mode === 'bucket') {
      if (k === 'lo') { v = 0; for (i = 0; i <= s.n; i++) if (s.stops[i] <= n) v = i; }
      else { v = s.n; for (i = s.n; i >= 0; i--) if (s.stops[i] >= n) v = i; }
    }
    set(s, k, v);
    inp.value = amount(s, k);
    commit(s);
  }
  /* typing in a box must not submit the facets form on every key: only the committed value does */
  document.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('cd-range__in')) e.stopPropagation();
  }, true);
  document.addEventListener('change', function (e) {
    if (e.target.classList && e.target.classList.contains('cd-range__in')) {
      e.stopPropagation();
      fromInput(e.target);
    }
  }, true);
  document.addEventListener('focusin', function (e) {
    if (e.target.classList && e.target.classList.contains('cd-range__in')) {
      try { e.target.select(); } catch (err) {}
    }
  });
})();
